import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { GroupPipe, OrderByGroupedPipe, SafePipe } from './pipes.pipe';

@NgModule({
    imports: [IonicModule, GroupPipe, OrderByGroupedPipe, SafePipe],
    exports: [GroupPipe, OrderByGroupedPipe, SafePipe]
})
export class PipesModule { }
